import React, {ReactElement} from 'react';
import ReportAnswerPercentage from '../../../../../incase-domain/components/report/answer/ReportAnswerPercentage';
import {QuestionAnswerEnum} from '../../../../../incase-domain/analytics';

const PLACEHOLDER_ANSWERS = [
    {label: 'Answer A', percentage: 42, type: QuestionAnswerEnum.CORRECT},
    {label: 'Answer B', percentage: 28, type: QuestionAnswerEnum.INCORRECT},
    {label: 'Answer C', percentage: 28, type: QuestionAnswerEnum.INCORRECT},
    {label: 'Answer D', percentage: 18, type: QuestionAnswerEnum.DEBATABLE},
] as const;

function QuestionReportPlaceholder(): ReactElement {
    return (
        <div className="c-questionLayout c-questionReport--placeholder" aria-hidden="true">
            <div className="c-questionLayout__header">
                <div className="c-questionTitle c-questionReport__placeholderTitle">Question</div>
            </div>
            <div className="c-questionLayout__body">
                <div className="c-questionReport">
                    <div className="c-questionReport__answers">
                        {PLACEHOLDER_ANSWERS.map((answer) => (
                            <div className="c-questionReport__answers-item" key={answer.label}>
                                <ReportAnswerPercentage
                                    label={answer.label}
                                    percentage={answer.percentage}
                                    type={answer.type}
                                    showCorrect
                                    isPresenter
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuestionReportPlaceholder;
